import React from 'react';

/**
 * Stateless keypad used for numeric entry without triggering the OS keyboard.
 */
const NumericKeypad = ({
  value = '',
  onChange,
  allowDecimal = false,
  className = '',
  replaceOnNext = false,
  onReplaceHandled,
}) => {
  const append = (symbol) => {
    if (!onChange) return;
    if (symbol === '.' && (!allowDecimal || value.includes('.'))) {
      return;
    }
    if (replaceOnNext) {
      onChange(String(symbol));
      if (onReplaceHandled) onReplaceHandled();
      return;
    }
    onChange((value || '') + symbol);
  };

  const handleDelete = () => {
    if (!onChange) return;
    onChange(value.slice(0, -1));
  };

  const handleClear = () => {
    if (!onChange) return;
    onChange('');
  };

  const buttons = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

  return (
    <div className={`grid grid-cols-3 gap-3 ${className}`}>
      {buttons.map((digit) => (
        <button
          key={digit}
          type="button"
          className="py-4 rounded-xl bg-slate-100 text-2xl font-semibold text-slate-800 hover:bg-slate-200"
          onClick={() => append(digit)}
        >
          {digit}
        </button>
      ))}
      {allowDecimal ? (
        <button
          type="button"
          className="py-4 rounded-xl bg-slate-100 text-2xl font-semibold text-slate-800 hover:bg-slate-200"
          onClick={() => append('.')}
        >
          .
        </button>
      ) : (
        <button
          type="button"
          className="py-4 rounded-xl bg-slate-100 text-lg font-semibold text-slate-800 hover:bg-slate-200"
          onClick={handleClear}
        >
          CLR
        </button>
      )}
      <button
        type="button"
        className="py-4 rounded-xl bg-slate-100 text-2xl font-semibold text-slate-800 hover:bg-slate-200"
        onClick={() => append('0')}
      >
        0
      </button>
      <button
        type="button"
        className="py-4 rounded-xl bg-slate-100 text-lg font-semibold text-slate-800 hover:bg-slate-200"
        onClick={handleDelete}
      >
        ⌫
      </button>
      {allowDecimal && (
        <button
          type="button"
          className="col-span-3 py-3 rounded-xl bg-slate-100 text-lg font-semibold text-slate-800 hover:bg-slate-200"
          onClick={handleClear}
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default NumericKeypad;
